import { Routes, Route } from 'react-router-dom'
import { ThemeProvider } from '@/contexts/ThemeContext'
import Header from '@/components/Header'
import Home from '@/pages/Home'
import Guide from '@/pages/Guide'
import QuickStart from '@/pages/QuickStart'
import Examples from '@/pages/Examples'
import Footer from '@/components/Footer'

function App() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
        <Header />
        <main className="pt-16">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/quick-start" element={<QuickStart />} />
            <Route path="/examples" element={<Examples />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  )
}

export default App
